import React from "react";

function TextInput({ placeholder, style, value, onChange }) {
  return (
    <input
      className={`w-full mb-5 border pt-3 pb-2 px-4 text-gray-500 border-gray-200 rounded-xl outline-none ${style}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
}
export default TextInput;
